import { AuthConstants as Constants } from "../types";

const TOKEN_STORAGE_KEY = "auth_accessToken";

const initialToken = localStorage.getItem(TOKEN_STORAGE_KEY);

const initialState = {
	user: null,
	loggedIn: !!initialToken,
	token: initialToken,
	error: null,
};

export function authReducer(state = initialState, action) {
	switch (action.type) {
		case Constants.LOGIN:
			const { accessToken, user } = action.payload;

			localStorage.setItem(TOKEN_STORAGE_KEY, accessToken);

			return {
				...state,
				loggedIn: true,
				token: accessToken,
				user: user,
				error: null,
			};
		case Constants.FAILED:
			return {
				...state,
				error: action.error,
			};
		case Constants.LOGOUT:
			localStorage.removeItem(TOKEN_STORAGE_KEY);

			return {
				...state,
				loggedIn: false,
				token: null,
				user: null,
				error: action.error,
			};

		default:
			return state;
	}
}
